var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGoogleG(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4073 10.722H25.3333V10.6667H13.3333V16H20.8687C19.7693 19.1047 16.8153 21.3333 13.3333 21.3333C8.91533 21.3333 5.33333 17.7513 5.33333 13.3333C5.33333 8.91533 8.91533 5.33333 13.3333 5.33333C15.3727 5.33333 17.228 6.10267 18.6407 7.35933L22.412 3.588C20.0307 1.36867 16.8453 0 13.3333 0C5.97 0 0 5.97 0 13.3333C0 20.6967 5.97 26.6667 13.3333 26.6667C20.6967 26.6667 26.6667 20.6967 26.6667 13.3333C26.6667 12.4393 26.5747 11.5667 26.4073 10.722Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53516 7.12733L5.91582 10.34C7.10116 7.40533 9.97182 5.33333 13.3312 5.33333C15.3705 5.33333 17.2258 6.10267 18.6385 7.35933L22.4098 3.588C20.0285 1.36867 16.8432 0 13.3312 0C8.20982 0 3.76849 2.89133 1.53516 7.12733Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3309 26.6658C16.7749 26.6658 19.9043 25.3478 22.2703 23.2045L18.1436 19.7125C16.8049 20.7265 15.1409 21.3325 13.3309 21.3325C9.86294 21.3325 6.91827 19.1212 5.80894 16.0352L1.46094 19.3852C3.6676 23.7032 8.14894 26.6658 13.3309 26.6658Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.406 10.7194H25.332V10.6641H13.332V15.9974H20.8674C20.3394 17.4887 19.38 18.7747 18.1427 19.7114C18.1434 19.7107 18.144 19.7107 18.1447 19.7101L22.2714 23.2021C21.9794 23.4674 26.6654 19.9974 26.6654 13.3307C26.6654 12.4367 26.5734 11.5641 26.406 10.7194Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogleG);
export default __webpack_public_path__ + "static/media/icon_google_g.86fbb928d603e0ac23ea16068adf90ec.svg";
export { ForwardRef as ReactComponent };